/*
  WS pre-order basket notices (15 Sep 2026).
  Orders are never split, so a pre-order line holds the whole order until release.
  For any cart line whose product is tagged pre_order this adds a "Pre-order" badge
  under the item name, and a note in the cart drawer and on the cart page that the
  order is sent together once the pre-order is released. Product tags are not in
  /cart.js, so each handle's tags are read once from /products/<handle>.js.
  Nothing is fetched while the basket is empty. Loaded site-wide by
  sections/ws-preorder-loader.liquid in the header group.
*/
(function () {
  if (window.wsPreorderInit) return;
  window.wsPreorderInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var tagCache = {};
  var busy = false;
  var again = false;
  var timer = null;
  var NOTE_HEAD = 'Your basket includes a pre-order';
  var NOTE_BODY = 'Everything in this order is sent together once the pre-order is released.';
  var NOTE_MIXED = ' Want your other items sooner? Place them as a separate order.';

  function tagsFor(handle) {
    if (!tagCache[handle]) {
      tagCache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
        .then(function (p) { return p.tags || []; })
        .catch(function () { return []; });
    }
    return tagCache[handle];
  }

  function rows() {
    return document.querySelectorAll('#CartDrawer .cart-item, .ws-cart .ws-item');
  }

  function handleOf(row) {
    var link = row.querySelector('.cart-item__name, .ws-item__name');
    if (!link) return null;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    return m ? { link: link, handle: decodeURIComponent(m[1]) } : null;
  }

  function childNotice(parent) {
    if (!parent) return null;
    for (var i = 0; i < parent.children.length; i++) {
      if (parent.children[i].classList.contains('ws-po-notice')) return parent.children[i];
    }
    return null;
  }

  function notice(host, where, show, mixed) {
    if (!host) return;
    var parent = where === 'afterend' ? host.parentNode : host;
    var existing = childNotice(parent);
    if (!show) {
      if (existing) existing.remove();
      return;
    }
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'ws-po-notice';
      existing.setAttribute('role', 'note');
      host.insertAdjacentElement(where, existing);
    }
    var text = NOTE_BODY + (mixed ? NOTE_MIXED : '');
    var strong = existing.querySelector('strong');
    var body = existing.querySelector('span');
    if (!strong || !body) {
      existing.innerHTML = '';
      strong = document.createElement('strong');
      strong.textContent = NOTE_HEAD;
      body = document.createElement('span');
      existing.appendChild(strong);
      existing.appendChild(body);
    }
    if (body.textContent !== text) body.textContent = text;
  }

  function apply(po, has, mixed) {
    Array.prototype.forEach.call(rows(), function (row) {
      var info = handleOf(row);
      if (!info) return;
      var badge = row.querySelector('.ws-po-badge');
      if (po[info.handle]) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ws-po-badge';
          badge.textContent = 'Pre-order';
          info.link.insertAdjacentElement('afterend', badge);
        }
      } else if (badge) {
        badge.remove();
      }
    });
    notice(document.querySelector('#CartDrawer .drawer__cart-items-wrapper'), 'afterend', has, mixed);
    notice(document.querySelector('.ws-cart__aside'), 'afterbegin', has, mixed);
  }

  function clearAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.ws-po-notice'), function (n) { n.remove(); });
  }

  function run() {
    if (!rows().length) {
      clearAll();
      return;
    }
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var handles = [];
        cart.items.forEach(function (it) {
          if (handles.indexOf(it.handle) < 0) handles.push(it.handle);
        });
        return Promise.all(handles.map(function (h) {
          return tagsFor(h).then(function (t) { return { h: h, po: t.indexOf('pre_order') > -1 }; });
        })).then(function (list) {
          var po = {};
          list.forEach(function (x) { if (x.po) po[x.h] = true; });
          var poLines = 0;
          cart.items.forEach(function (it) { if (po[it.handle]) poLines++; });
          apply(po, poLines > 0, poLines > 0 && poLines < cart.items.length);
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) {
          again = false;
          run();
        }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 200);
  }

  function isOurs(n) {
    return n.nodeType === 1 && (n.classList.contains('ws-po-notice') || n.classList.contains('ws-po-badge'));
  }

  function relevant(m) {
    var t = m.target;
    if (t && t.nodeType === 1 && t.closest && t.closest('.ws-po-notice, .ws-po-badge')) return false;
    var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
    for (var i = 0; i < nodes.length; i++) {
      if (!isOurs(nodes[i])) return true;
    }
    return false;
  }

  function observe(el) {
    if (!el || el.wsPoObserved) return;
    el.wsPoObserved = true;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (relevant(muts[i])) {
          schedule();
          return;
        }
      }
    }).observe(el, { childList: true, subtree: true });
  }

  function init() {
    observe(document.getElementById('CartDrawer'));
    observe(document.getElementById('main-cart-items'));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
